/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Footer_Privacy_PolicyInputs */

const es_footer_privacy_policy = /** @type {(inputs: Footer_Privacy_PolicyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Politica de Privacidad`)
};

const en_footer_privacy_policy = /** @type {(inputs: Footer_Privacy_PolicyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Privacy Policy`)
};

/**
* | output |
* | --- |
* | "Privacy Policy" |
*
* @param {Footer_Privacy_PolicyInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const footer_privacy_policy = /** @type {((inputs?: Footer_Privacy_PolicyInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Footer_Privacy_PolicyInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_footer_privacy_policy(inputs)
	return en_footer_privacy_policy(inputs)
});
export { footer_privacy_policy as "footer.privacy_policy" }